import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      fill="none"
      viewBox="0 0 72 72"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="10"
        d="M5 67L67 5M5 5l62 62"
      ></path>
    </svg>
  );
}

export default Icon;
